module.exports = __webpack_public_path__ + "img/calendar.5cb5762a.svg";